// extracted by mini-css-extract-plugin
module.exports = {"Header":"autocomplete-search_Header__p12cy","Button":"autocomplete-search_Button__ybzMH"};